<section class="w-[420px] max-w-full">
  <h3 class="text-lg font-semibold text-gray-900">Supprimer le document ?</h3>
  <p class="text-sm text-gray-600 mt-2">
    Vous êtes sur le point de supprimer
    <span class="font-medium text-gray-900 break-all">« {{ fileName() }} »</span>.
    Cette action est irréversible.
  </p>

  <div class="flex justify-end gap-2 mt-6">
    <button
      type="button"
      (click)="cancel()"
      class="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50 cursor-pointer"
    >
      Annuler
    </button>
    <button
      type="button"
      (click)="confirm()"
      class="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700 cursor-pointer"
    >
      Supprimer
    </button>
  </div>
</section>
